export const calcDrawingItemLength = (item, minLength = 0) => {
  let total = 0;
  let forPrice = 0;

  let sumTotalLength = 0;
  let sumLengthForPrice = 0;

  if (item && Object.keys(item).length && !item.isDeleted && item.subitems.length) {
    Object.keys(item.subitems).map((itemDrawing) => {
      const { amount, length } = item.tempUid ? item.subitems[itemDrawing] : item;
      const amountInt = parseInt(amount, 10);
      let lengthInt = parseInt(length, 10);

      sumTotalLength = amountInt * lengthInt;

      if (lengthInt < minLength) {
        lengthInt = minLength;
      }

      sumLengthForPrice = amountInt * lengthInt;

      total += sumTotalLength;
      forPrice += sumLengthForPrice;

      return { total, forPrice };
    });
  }

  return { total, forPrice };
};
